// Given a text that can be in markdown but only in asterisk like *italic* or **bold** or ***bold italic***
// Example Hola que tal es *Hey What's up* en inglés
// i want to extract in array every word like this.
// [{word: 'Hola', tag: ''}, {word: 'que', tag: ''}, {word: 'tal', tag: ''}, {word: 'es', tag: ''}, {word: 'Hey', tag: 'italic'}, {word: 'What's', tag: 'italic'}, {word: 'up', tag: 'italic'}, {word: 'en', tag: ''}, {word: 'inglés', tag: ''}]

export function extractTags(text: string): { word: string; tag: string }[] {
  const result: { word: string; tag: string }[] = [];
  const tagStack: string[] = [];
  // Regex to match markdown markers (***, **, *) or spaces or sequences of non-space/non-asterisk characters (words with punctuation)
  const regex = /(\*\*\*|\*\*|\*|\s+|[^\s\*]+)/g;
  let match;

  while ((match = regex.exec(text)) !== null) {
    const token = match[0];

    if (token.trim() === '') {
      // Ignore spaces
      continue;
    }

    if (token === '***') {
      if (tagStack.length > 0 && tagStack[tagStack.length - 1] === 'bold italic') {
        tagStack.pop(); // Closing bold italic
      } else {
        tagStack.push('bold italic'); // Opening bold italic
      }
    } else if (token === '**') {
      if (tagStack.length > 0 && tagStack[tagStack.length - 1] === 'bold') {
        tagStack.pop(); // Closing bold
      } else {
        tagStack.push('bold'); // Opening bold
      }
    } else if (token === '*') {
      if (tagStack.length > 0 && tagStack[tagStack.length - 1] === 'italic') {
        tagStack.pop(); // Closing italic
      } else {
        tagStack.push('italic'); // Opening italic
      }
    } else {
      // It's a word (including punctuation)
      const currentTag = tagStack.length > 0 ? tagStack[tagStack.length - 1] : '';
      result.push({ word: token, tag: currentTag });
    }
  }

  // Note: This implementation assumes correctly matched opening and closing tags.
  // Unclosed tags at the end of the string will be ignored.

  return result;
}
